// Shared navigation for the marketing pages (/, /what-is, /how-different,
// /who-its-for, /calculators, /blog). One component so the brand is applied
// once. `ground` picks the colourway: 'blue' for a Finance Blue hero,
// 'light' for white or Mist pages.
import React from 'react';
import { Link } from 'react-router-dom';
import SignupLink from '../Auth/SignupLink';
import Logo from '../Brand/BrandLogo';

export const MARKETING_LINKS = [
  { to: '/what-is', label: 'What it is' },
  { to: '/how-different', label: 'How it’s different' },
  { to: '/who-its-for', label: 'Who it’s for' },
  { to: '/calculators', label: 'Calculators' },
  { to: '/blog', label: 'Blog' },
];

const MarketingNav = ({ ground = 'blue', className = '' }) => {
  const onBlue = ground === 'blue';
  const link = onBlue
    ? 'text-white/85 hover:text-white transition-colors'
    : 'text-midnight/75 hover:text-midnight transition-colors';
  const cta = onBlue
    ? 'bg-white text-finance-blue hover:bg-mist px-4 py-2 rounded-lg font-bold transition-colors'
    : 'bg-finance-blue text-white hover:bg-finance-blue-600 px-4 py-2 rounded-lg font-bold transition-colors';

  return (
    <nav className={`relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 ${className}`} aria-label="Primary">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link to="/" aria-label="Finance Forecaster home" className="-ml-3">
            <Logo variant={onBlue ? 'onBlue' : 'onLight'} size="sm" />
          </Link>
          <div className="hidden md:flex items-center gap-6 text-sm font-medium">
            {MARKETING_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className={link}>{l.label}</Link>
            ))}
          </div>
        </div>
        <div className="flex items-center gap-4 text-sm">
          <Link to="/login" className={`${link} font-medium`}>Sign in</Link>
          <SignupLink className={cta} closedLabel="Join the waitlist">Get started</SignupLink>
        </div>
      </div>
      <div className="flex flex-wrap md:hidden items-center justify-center gap-x-4 gap-y-2 mt-4 text-sm font-medium">
        {MARKETING_LINKS.map((l) => (
          <Link key={l.to} to={l.to} className={link}>{l.label}</Link>
        ))}
      </div>
    </nav>
  );
};

export default MarketingNav;
